module.exports = "# Get Into Your Teams\n\n## Content\n\n###### Get into your teams!\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/05_teamIntro/teamIntro.md
// module id = 1523
// module chunks = 2